import React from 'react';
import type { PriorityProps } from '../../common/types.tsx';
import { PriorityIcon } from '../../common/ui/priority-icon/index.tsx';

export const PriorityChipRead = ({ name, iconUrl }: PriorityProps) => (
	<PriorityIcon name={name} iconUrl={iconUrl} />
);
